import React from "react";
import { useNavigate } from "react-router-dom";
import Datatable from "./common/datatable";
import { useViewIndustryQuery } from "../hooks/industry/industryList";
import { useViewCategory } from "../hooks/categorys/category.showall";
import ActionMenu from "./common/menu";
import FallbackImage from "./common/fallbackImage";
import { toListArray } from "../utils/parsePaginatedResponse";

const ClientData = ({ data, onEdit, onView, onDelete }) => {
  const navigate = useNavigate();

  const handleView = (client) => {
    const id = client._id || client.id;
    navigate(`/clients/view/${id}`);
  };

  const { data: industriesData } = useViewIndustryQuery();
  const { data: categoriesData } = useViewCategory();

  const industriesList = toListArray(industriesData, ["industry", "industries"]);
  const categoriesList = toListArray(categoriesData, ["categories", "category"]);

  const getIndustryTitle = (val) => {
    if (!val || (Array.isArray(val) && val.length === 0)) return '-';

    if (Array.isArray(val)) {
      return val.map(item => {
        if (typeof item === 'string') {
          const found = industriesList.find(i => i._id === item || i.id === item);
          return found ? found.title : item;
        }
        if (item && item.title) return item.title;
        if (item && item._id) {
          const found = industriesList.find(i => i._id === item._id || i.id === item._id);
          return found ? found.title : item._id;
        }
        return '-';
      }).join(', ');
    }

    if (typeof val === 'string') {
      const found = industriesList.find(i => i._id === val || i.id === val);
      return found ? found.title : val;
    }

    if (typeof val === 'object') {
      if (val.title) return val.title;
      if (val._id) {
        const found = industriesList.find(i => i._id === val._id || i.id === val._id);
        return found ? found.title : val._id;
      }
    }

    return '-';
  };

  const getCategoryTitle = (val) => {
    if (!val || (Array.isArray(val) && val.length === 0)) return '-';

    if (Array.isArray(val)) {
      return val.map(item => {
        if (typeof item === 'string') {
          const found = categoriesList.find(c => c._id === item || c.id === item);
          return found ? found.title : item;
        }
        if (item && item.title) return item.title;
        if (item && item._id) {
          const found = categoriesList.find(c => c._id === item._id || c.id === item._id);
          return found ? found.title : item._id;
        }
        return '-';
      }).join(', ');
    }

    if (typeof val === 'string') {
      const found = categoriesList.find(c => c._id === val || c.id === val);
      return found ? found.title : val;
    }

    if (typeof val === 'object') {
      if (val.title) return val.title;
      if (val._id) {
        const found = categoriesList.find(c => c._id === val._id || c.id === val._id);
        return found ? found.title : val._id;
      }
    }

    return '-';
  };

  const columns = [
    {
      key: "logo",
      label: "Logo",
      className: "company-logo",
      render: (value) =>
        value ? (
          <FallbackImage src={value} alt="Logo" style={{ width: 32, height: 32, borderRadius: "4px", objectFit: "cover" }} />
        ) : null,
    },
    { key: "name", label: "Company Name" },
    { key: "email", label: "Email", render: (value) => <span className="tab-tds">{value}</span> },
    { key: "phone", label: "Phone", render: (value) => <span className="tab-tds">{value}</span> },
    { key: "country", label: "Country", render: (value, row) => row.country || row.location || '-' },
    {
      key: "industry",
      label: "Industry Title",
      render: (value) => getIndustryTitle(value)
    },
    {
      key: "category",
      label: "Category Title",
      render: (value) => getCategoryTitle(value)
    },
    {
      key: "actions",
      label: "Actions",
      render: (value, row) => (
        <ActionMenu 
          row={row}
          onView={handleView}
          onEdit={onEdit}
          onDelete={onDelete}
        />
      ),
    },
  ];
  return (
    <>
      <Datatable
        data={data}
        columns={columns}
      />
    </>
  );
};

export default ClientData;
